const { on } = window.ivent;

on(document, 'keydown', (e) => {
	if (
		e.key === '/' ||
		(e.key === 'k' && (e.metaKey /* for Mac */ || /* for non-Mac */ e.ctrlKey))
	) {
		window.location.hash = '#/search';
	}
});
